/*
 * File: CustomDatePicker.tsx
 * Project: a-a
 * File Created: Thursday, 20th February 2025 4:47:49 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Friday, 17th October 2025 7:59:07 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from 'dayjs';
import { TextField } from '@mui/material';
import zeplinColor from '../../../theme/Color';

const CustomDatePicker = ({
  value,
  setValue,
  label,
  required = false,
  size = 'medium',
}: {
  value: Dayjs | null;
  label?: string;
  size?: 'small' | 'medium';
  setValue: React.Dispatch<React.SetStateAction<Dayjs | null>>;
  required?: boolean;
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label ? label : 'Due date'}
        sx={{ width: '100%', '& .MuiFormLabel-asterisk': { color: zeplinColor.Error } }}
        // format='DD MMM, YYYY'
        // slotProps={{
        //   textField: {
        //     InputProps: {
        //       endAdornment: <img src={'/assets/calendar.svg'} width={19} height={19} />,
        //     },
        //   },
        // }}
        // slots={{ field: SingleInputDateRangeField }}
        slotProps={{
          textField: {
            required: required ? true : false,
            size: size ? size : 'medium',
          },
        }}
        value={value || null}
        onChange={(newValue) => setValue(newValue)}
        slots={{
          openPickerIcon: () => <img src={'/assets/calendar.svg'} width={19} height={19} />,
        }}
        //  slotProps={(params:any) => (
        //     <TextField
        //       {...params}
        //       value={value ? dayjs(value).format('D MMM, YYYY') : ''}
        //       InputProps={{
        //         ...params.InputProps,
        //         endAdornment: (
        //           <>
        //             {params.InputProps?.endAdornment}
        //             <img src={'/assets/calendar.svg'} width={19} height={19} />
        //           </>
        //         ),
        //       }}
        //   />
        // )}
      />
    </LocalizationProvider>
  );
};

export default CustomDatePicker;
